import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12","key":"svg-0"}],["path",{"d":"M7 13l10 0","key":"svg-1"}]]

/**
 * IconLetterA
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWEiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgMjB2LTEyYTQgNCAwIDAgMSA0IC00aDJhNCA0IDAgMCAxIDQgNHYxMiIgLz4KICA8cGF0aCBkPSJNNyAxM2wxMCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/letter-a
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterA = createReactComponent('outline', 'letter-a', 'LetterA', __iconNode);

export default IconLetterA;